"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9460],{

/***/ 27190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* binding */ Accordion; },
  "KF": function() { return /* binding */ AccordionButton; },
  "XE": function() { return /* binding */ AccordionIcon; },
  "Qd": function() { return /* binding */ AccordionItem; },
  "Hk": function() { return /* binding */ AccordionPanel; }
});

// UNUSED EXPORTS: AccordionProvider, useAccordion, useAccordionContext, useAccordionItem, useAccordionItemState, useAccordionStyles

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js
var index_esm = __webpack_require__(83904);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.esm.js
var dist_index_esm = __webpack_require__(28387);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js
var react_use_merge_refs_dist_index_esm = __webpack_require__(76734);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/descendant/dist/index.esm.js
// src/use-descendant.ts




// src/utils.ts

function sortNodes(nodes) {
  return nodes.sort((a, b) => {
    const compare = a.compareDocumentPosition(b);
    if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    }
    if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    }
    if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) {
      throw Error("Cannot sort the given nodes.");
    } else {
      return 0;
    }
  });
}
var isElement = (el) => typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function getNextIndex(current, max, loop) {
  let next = current + 1;
  if (loop && next >= max)
    next = 0;
  return next;
}
function getPrevIndex(current, max, loop) {
  let next = current - 1;
  if (loop && next < 0)
    next = max;
  return next;
}
var useSafeLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;
var cast = (value) => value;

// src/descendant.ts
var DescendantsManager = class {
  descendants = /* @__PURE__ */ new Map();
  register = (nodeOrOptions) => {
    if (nodeOrOptions == null)
      return;
    if (isElement(nodeOrOptions)) {
      return this.registerNode(nodeOrOptions);
    }
    return (node) => {
      this.registerNode(node, nodeOrOptions);
    };
  };
  unregister = (node) => {
    this.descendants.delete(node);
    const sorted = sortNodes(Array.from(this.descendants.keys()));
    this.assignIndex(sorted);
  };
  destroy = () => {
    this.descendants.clear();
  };
  assignIndex = (descendants) => {
    this.descendants.forEach((descendant) => {
      const index = descendants.indexOf(descendant.node);
      descendant.index = index;
      descendant.node.dataset["index"] = descendant.index.toString();
    });
  };
  count = () => this.descendants.size;
  enabledCount = () => this.enabledValues().length;
  values = () => {
    const values = Array.from(this.descendants.values());
    return values.sort((a, b) => a.index - b.index);
  };
  enabledValues = () => {
    return this.values().filter((descendant) => !descendant.disabled);
  };
  item = (index) => {
    if (this.count() === 0)
      return void 0;
    return this.values()[index];
  };
  enabledItem = (index) => {
    if (this.enabledCount() === 0)
      return void 0;
    return this.enabledValues()[index];
  };
  first = () => this.item(0);
  firstEnabled = () => this.enabledItem(0);
  last = () => this.item(this.descendants.size - 1);
  lastEnabled = () => {
    const lastIndex = this.enabledValues().length - 1;
    return this.enabledItem(lastIndex);
  };
  indexOf = (node) => {
    var _a;
    if (!node)
      return -1;
    return ((_a = this.descendants.get(node)) == null ? void 0 : _a.index) ?? -1;
  };
  enabledIndexOf = (node) => {
    if (node == null)
      return -1;
    return this.enabledValues().findIndex((i) => i.node.isSameNode(node));
  };
  next = (index, loop = true) => {
    const next = getNextIndex(index, this.count(), loop);
    return this.item(next);
  };
  nextEnabled = (index, loop = true) => {
    const item = this.item(index);
    if (!item)
      return;
    const enabledIndex = this.enabledIndexOf(item.node);
    const nextEnabledIndex = getNextIndex(enabledIndex, this.enabledCount(), loop);
    return this.enabledItem(nextEnabledIndex);
  };
  prev = (index, loop = true) => {
    const prev = getPrevIndex(index, this.count() - 1, loop);
    return this.item(prev);
  };
  prevEnabled = (index, loop = true) => {
    const item = this.item(index);
    if (!item)
      return;
    const enabledIndex = this.enabledIndexOf(item.node);
    const prevEnabledIndex = getPrevIndex(enabledIndex, this.enabledCount() - 1, loop);
    return this.enabledItem(prevEnabledIndex);
  };
  registerNode = (node, options) => {
    if (!node || this.descendants.has(node))
      return;
    const keys = Array.from(this.descendants.keys()).concat(node);
    const sorted = sortNodes(keys);
    if (options == null ? void 0 : options.disabled) {
      options.disabled = !!options.disabled;
    }
    const descendant = { node, index: -1, ...options };
    this.descendants.set(node, descendant);
    this.assignIndex(sorted);
  };
};

// src/use-descendant.ts
function useDescendants() {
  const descendants = (0,react.useRef)(new DescendantsManager());
  useSafeLayoutEffect(() => {
    return () => descendants.current.destroy();
  });
  return descendants.current;
}
var [DescendantsContextProvider, useDescendantsContext] = (0,dist_index_esm/* createContext */.k)({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function useDescendant(options) {
  const descendants = useDescendantsContext();
  const [index, setIndex] = (0,react.useState)(-1);
  const ref = (0,react.useRef)(null);
  useSafeLayoutEffect(() => {
    return () => {
      if (!ref.current)
        return;
      descendants.unregister(ref.current);
    };
  }, []);
  useSafeLayoutEffect(() => {
    if (!ref.current)
      return;
    const dataIndex = Number(ref.current.dataset["index"]);
    if (index != dataIndex && !Number.isNaN(dataIndex)) {
      setIndex(dataIndex);
    }
  });
  const refCallback = options ? cast(descendants.register(options)) : cast(descendants.register);
  return {
    descendants,
    index,
    enabledIndex: descendants.enabledIndexOf(ref.current),
    register: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(refCallback, ref)
  };
}
function createDescendantContext() {
  const ContextProvider = cast(DescendantsContextProvider);
  const _useDescendantsContext = () => cast(useDescendantsContext());
  const _useDescendant = (options) => useDescendant(options);
  const _useDescendants = () => useDescendants();
  return [
    ContextProvider,
    _useDescendantsContext,
    _useDescendants,
    _useDescendant
  ];
}


// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-controllable-state/dist/index.esm.js
var react_use_controllable_state_dist_index_esm = __webpack_require__(98053);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(71197);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var styled_system_dist_index_esm = __webpack_require__(54520);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js
// ../../../react-shim.js


// src/accordion-button.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/accordion-context.ts


var [AccordionStylesProvider, useAccordionStyles] = (0,dist_index_esm/* createContext */.k)({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
});
var [AccordionItemProvider, useAccordionItemContext] = (0,dist_index_esm/* createContext */.k)({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
});
var [
  AccordionDescendantsProvider,
  useAccordionDescendantsContext,
  useAccordionDescendants,
  useAccordionDescendant
] = createDescendantContext();

// src/accordion-button.tsx
var AccordionButton = (0,index_esm/* forwardRef */.Gp)(function AccordionButton2(props, ref) {
  const { getButtonProps } = useAccordionItemContext();
  const buttonProps = getButtonProps(props, ref);
  const styles = useAccordionStyles();
  const buttonStyles = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    outline: 0,
    ...styles.button
  };
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.button */.m$.button, {
    ...buttonProps,
    className: cx("chakra-accordion__button", props.className),
    __css: buttonStyles
  });
});
AccordionButton.displayName = "AccordionButton";

// src/accordion-icon.tsx


// src/use-accordion.ts




function useAccordion(props) {
  const {
    onChange,
    defaultIndex,
    index: indexProp,
    allowMultiple,
    allowToggle,
    ...htmlProps
  } = props;
  allowMultipleWarning(props);
  allowMultipleAndAllowToggleWarning(props);
  const descendants = useAccordionDescendants();
  const [focusedIndex, setFocusedIndex] = (0,react.useState)(-1);
  (0,react.useEffect)(() => {
    return () => {
      setFocusedIndex(-1);
    };
  }, []);
  const [index, setIndex] = (0,react_use_controllable_state_dist_index_esm/* useControllableState */.T)({
    value: indexProp,
    defaultValue() {
      if (allowMultiple)
        return defaultIndex ?? [];
      return defaultIndex ?? -1;
    },
    onChange
  });
  const getAccordionItemProps = (idx) => {
    let isOpen = false;
    if (idx !== null) {
      isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
    }
    const onChange2 = (isOpen2) => {
      if (idx === null)
        return;
      if (allowMultiple && Array.isArray(index)) {
        const nextState = isOpen2 ? index.concat(idx) : index.filter((i) => i !== idx);
        setIndex(nextState);
      } else if (isOpen2) {
        setIndex(idx);
      } else if (allowToggle) {
        setIndex(-1);
      }
    };
    return { isOpen, onChange: onChange2 };
  };
  return {
    index,
    setIndex,
    htmlProps,
    getAccordionItemProps,
    focusedIndex,
    setFocusedIndex,
    descendants
  };
}
var [AccordionProvider, useAccordionContext] = (0,dist_index_esm/* createContext */.k)({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function useAccordionItem(props) {
  const { isDisabled, isFocusable, id, ...htmlProps } = props;
  const { getAccordionItemProps, setFocusedIndex } = useAccordionContext();
  const buttonRef = (0,react.useRef)(null);
  const reactId = (0,react.useId)();
  const uid = id ?? reactId;
  const buttonId = `accordion-button-${uid}`;
  const panelId = `accordion-panel-${uid}`;
  focusableNotDisabledWarning(props);
  const { register, index, descendants } = useAccordionDescendant({
    disabled: isDisabled && !isFocusable
  });
  const { isOpen, onChange } = getAccordionItemProps(index === -1 ? null : index);
  warnIfOpenAndDisabled({ isOpen, isDisabled });
  const onOpen = () => {
    onChange == null ? void 0 : onChange(true);
  };
  const onClose = () => {
    onChange == null ? void 0 : onChange(false);
  };
  const onClick = (0,react.useCallback)(() => {
    onChange == null ? void 0 : onChange(!isOpen);
    setFocusedIndex(index);
  }, [index, setFocusedIndex, isOpen, onChange]);
  const onKeyDown = (0,react.useCallback)((event) => {
    const keyMap = {
      ArrowDown: () => {
        const next = descendants.nextEnabled(index);
        next == null ? void 0 : next.node.focus();
      },
      ArrowUp: () => {
        const prev = descendants.prevEnabled(index);
        prev == null ? void 0 : prev.node.focus();
      },
      Home: () => {
        const first = descendants.firstEnabled();
        first == null ? void 0 : first.node.focus();
      },
      End: () => {
        const last = descendants.lastEnabled();
        last == null ? void 0 : last.node.focus();
      }
    };
    const action = keyMap[event.key];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, index]);
  const onFocus = (0,react.useCallback)(() => {
    setFocusedIndex(index);
  }, [setFocusedIndex, index]);
  const getButtonProps = (0,react.useCallback)(function getButtonProps2(props2 = {}, ref = null) {
    return {
      ...props2,
      type: "button",
      ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(register, buttonRef, ref),
      id: buttonId,
      disabled: !!isDisabled,
      "aria-expanded": !!isOpen,
      "aria-controls": panelId,
      onClick: callAllHandlers(props2.onClick, onClick),
      onFocus: callAllHandlers(props2.onFocus, onFocus),
      onKeyDown: callAllHandlers(props2.onKeyDown, onKeyDown)
    };
  }, [
    buttonId,
    isDisabled,
    isOpen,
    onClick,
    onFocus,
    onKeyDown,
    panelId,
    register
  ]);
  const getPanelProps = (0,react.useCallback)(function getPanelProps2(props2 = {}, ref = null) {
    return {
      ...props2,
      ref,
      role: "region",
      id: panelId,
      "aria-labelledby": buttonId,
      hidden: !isOpen
    };
  }, [buttonId, isOpen, panelId]);
  return {
    isOpen,
    isDisabled,
    isFocusable,
    onOpen,
    onClose,
    getButtonProps,
    getPanelProps,
    htmlProps
  };
}
function allowMultipleWarning(props) {
  const index = props.index || props.defaultIndex;
  const condition = index != null && !Array.isArray(index) && props.allowMultiple;
  warn({
    condition: !!condition,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof index},`
  });
}
function allowMultipleAndAllowToggleWarning(props) {
  warn({
    condition: !!(props.allowMultiple && props.allowToggle),
    message: `If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not`
  });
}
function focusableNotDisabledWarning(props) {
  warn({
    condition: !!(props.isFocusable && !props.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function warnIfOpenAndDisabled(props) {
  warn({
    condition: props.isOpen && !!props.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}

// src/accordion-icon.tsx
function AccordionIcon(props) {
  const { isOpen, isDisabled } = useAccordionItemContext();
  const { reduceMotion } = useAccordionContext();
  const _className = cx("chakra-accordion__icon", props.className);
  const styles = useAccordionStyles();
  const iconStyles = {
    opacity: isDisabled ? 0.4 : 1,
    transform: isOpen ? "rotate(-180deg)" : void 0,
    transition: reduceMotion ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...styles.icon
  };
  return /* @__PURE__ */ react.createElement(icon_dist_index_esm/* Icon */.JO, {
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    className: _className,
    __css: iconStyles,
    ...props
  }, /* @__PURE__ */ react.createElement("path", {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }));
}
AccordionIcon.displayName = "AccordionIcon";

// src/accordion-item.tsx


var AccordionItem = (0,index_esm/* forwardRef */.Gp)(function AccordionItem2(props, ref) {
  const { children, className } = props;
  const { htmlProps, ...context } = useAccordionItem(props);
  const styles = useAccordionStyles();
  const containerStyles = {
    ...styles.container,
    overflowAnchor: "none"
  };
  const ctx = (0,react.useMemo)(() => context, [context]);
  return /* @__PURE__ */ react.createElement(AccordionItemProvider, {
    value: ctx
  }, /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ref,
    ...htmlProps,
    className: cx("chakra-accordion__item", className),
    __css: containerStyles
  }, typeof children === "function" ? children({
    isExpanded: !!context.isOpen,
    isDisabled: !!context.isDisabled
  }) : children));
});
AccordionItem.displayName = "AccordionItem";

// src/accordion-panel.tsx


var AccordionPanel = (0,index_esm/* forwardRef */.Gp)(function AccordionPanel2(props, ref) {
  const { className, motionProps, ...rest } = props;
  const { reduceMotion } = useAccordionContext();
  const { getPanelProps, isOpen } = useAccordionItemContext();
  const panelProps = getPanelProps(rest, ref);
  const _className = cx("chakra-accordion__panel", className);
  const styles = useAccordionStyles();
  if (!reduceMotion) {
    delete panelProps.hidden;
  }
  const child = /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ...panelProps,
    __css: styles.panel,
    className: _className
  });
  if (!reduceMotion) {
    return /* @__PURE__ */ react.createElement(transition_dist_index_esm/* Collapse */.UO, {
      in: isOpen,
      ...motionProps
    }, child);
  }
  return child;
});
AccordionPanel.displayName = "AccordionPanel";

// src/accordion.tsx


var Accordion = (0,index_esm/* forwardRef */.Gp)(function Accordion2({ children, reduceMotion, ...props }, ref) {
  const styles = (0,index_esm/* useMultiStyleConfig */.jC)("Accordion", props);
  const ownProps = (0,styled_system_dist_index_esm/* omitThemingProps */.Lr)(props);
  const { htmlProps, descendants, ...context } = useAccordion(ownProps);
  const ctx = (0,react.useMemo)(() => ({ ...context, reduceMotion: !!reduceMotion }), [context, reduceMotion]);
  return /* @__PURE__ */ react.createElement(AccordionDescendantsProvider, {
    value: descendants
  }, /* @__PURE__ */ react.createElement(AccordionProvider, {
    value: ctx
  }, /* @__PURE__ */ react.createElement(AccordionStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ref,
    ...htmlProps,
    className: cx("chakra-accordion", props.className),
    __css: styles.root
  }, children))));
});
Accordion.displayName = "Accordion";

// src/use-accordion-item-state.ts
function useAccordionItemState() {
  const { isOpen, isDisabled, onClose, onOpen } = useAccordionItemContext();
  return { isOpen, onClose, isDisabled, onOpen };
}



/***/ }),

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 98053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useControllableState; }
/* harmony export */ });
/* unused harmony export useControllableProp */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19251);
// src/index.ts


function useControllableProp(prop, state) {
  const controlled = typeof prop !== "undefined";
  const value = controlled ? prop : state;
  return useMemo(() => [controlled, value], [controlled, value]);
}
function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange,
    shouldUpdate = (prev, next) => prev !== next
  } = props;
  const onChangeProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onChange);
  const shouldUpdateProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(shouldUpdate);
  const [uncontrolledState, setUncontrolledState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue);
  const controlled = valueProp !== void 0;
  const value = controlled ? valueProp : uncontrolledState;
  const setValue = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)((next) => {
    const setter = next;
    const nextValue = typeof next === "function" ? setter(value) : next;
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!controlled) {
      setUncontrolledState(nextValue);
    }
    onChangeProp(nextValue);
  }, [controlled, onChangeProp, value, shouldUpdateProp]);
  return [value, setValue];
}



/***/ }),

/***/ 71197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mi": function() { return /* binding */ Slide; },
/* harmony export */   "Qh": function() { return /* binding */ scaleFadeConfig; },
/* harmony export */   "UO": function() { return /* binding */ Collapse; },
/* harmony export */   "Xc": function() { return /* binding */ slideFadeConfig; },
/* harmony export */   "uf": function() { return /* binding */ fadeConfig; }
/* harmony export */ });
/* unused harmony exports EASINGS, Fade, ScaleFade, SlideFade, getSlideTransition, withDelay */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84441);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9882);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};

// src/collapse.tsx



// src/transition-utils.ts
var TRANSITION_EASINGS = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
var TRANSITION_VARIANTS = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function getSlideTransition(options) {
  const side = (options == null ? void 0 : options.direction) ?? "right";
  switch (side) {
    case "right":
      return TRANSITION_VARIANTS.slideRight;
    case "left":
      return TRANSITION_VARIANTS.slideLeft;
    case "bottom":
      return TRANSITION_VARIANTS.slideDown;
    case "top":
      return TRANSITION_VARIANTS.slideUp;
    default:
      return TRANSITION_VARIANTS.slideRight;
  }
}
var TRANSITION_DEFAULTS = {
  enter: {
    duration: 0.2,
    ease: TRANSITION_EASINGS.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TRANSITION_EASINGS.easeIn
  }
};
var withDelay = {
  enter: (transition, delay) => ({
    ...transition,
    delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
  }),
  exit: (transition, delay) => ({
    ...transition,
    delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
  })
};

// src/collapse.tsx
var isNumeric = (value) => value != null && parseInt(value.toString(), 10) > 0;
var defaultTransitions = {
  exit: {
    height: { duration: 0.2, ease: TRANSITION_EASINGS.ease },
    opacity: { duration: 0.3, ease: TRANSITION_EASINGS.ease }
  },
  enter: {
    height: { duration: 0.3, ease: TRANSITION_EASINGS.ease },
    opacity: { duration: 0.4, ease: TRANSITION_EASINGS.ease }
  }
};
var variants = {
  exit: ({
    animateOpacity,
    startingHeight,
    transition,
    transitionEnd,
    delay
  }) => ({
    ...animateOpacity && { opacity: isNumeric(startingHeight) ? 1 : 0 },
    height: startingHeight,
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(defaultTransitions.exit, delay)
  }),
  enter: ({
    animateOpacity,
    endingHeight,
    transition,
    transitionEnd,
    delay
  }) => ({
    ...animateOpacity && { opacity: 1 },
    height: endingHeight,
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(defaultTransitions.enter, delay)
  })
};
var Collapse = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const {
    in: isOpen,
    unmountOnExit,
    animateOpacity = true,
    startingHeight = 0,
    endingHeight = "auto",
    style,
    className,
    transition,
    transitionEnd,
    ...rest
  } = props;
  const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const timeout = setTimeout(() => {
      setMounted(true);
    });
    return () => clearTimeout(timeout);
  }, []);
  warn({
    condition: Boolean(startingHeight > 0 && unmountOnExit),
    message: `startingHeight and unmountOnExit are mutually exclusive. You can't use them together`
  });
  const hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
  const custom = {
    startingHeight,
    endingHeight,
    animateOpacity,
    transition: !mounted ? { enter: { duration: 0 } } : transition,
    transitionEnd: {
      enter: transitionEnd == null ? void 0 : transitionEnd.enter,
      exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : {
        ...transitionEnd == null ? void 0 : transitionEnd.exit,
        display: hasStartingHeight ? "block" : "none"
      }
    }
  };
  const show = unmountOnExit ? isOpen : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    initial: false,
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    ...rest,
    className: cx("chakra-collapse", className),
    style: {
      overflow: "hidden",
      display: "block",
      ...style
    },
    custom,
    variants,
    initial: unmountOnExit ? "exit" : false,
    animate,
    exit: "exit"
  }));
});
Collapse.displayName = "Collapse";

// src/fade.tsx


var variants2 = {
  enter: ({ transition, transitionEnd, delay } = {}) => ({
    opacity: 1,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
  }),
  exit: ({ transition, transitionEnd, delay } = {}) => ({
    opacity: 0,
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
  })
};
var fadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants2
};
var Fade = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Fade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const custom = { transition, transitionEnd, delay };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    className: cx("chakra-fade", className),
    custom,
    ...fadeConfig,
    animate,
    ...rest
  }));
});
Fade.displayName = "Fade";

// src/scale-fade.tsx


var variants3 = {
  exit: ({ reverse, initialScale, transition, transitionEnd, delay }) => ({
    opacity: 0,
    ...reverse ? { scale: initialScale, transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit } : { transitionEnd: { scale: initialScale, ...transitionEnd == null ? void 0 : transitionEnd.exit } },
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
  }),
  enter: ({ transitionEnd, transition, delay }) => ({
    opacity: 1,
    scale: 1,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
  })
};
var scaleFadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants3
};
var ScaleFade = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function ScaleFade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    reverse = true,
    initialScale = 0.95,
    className,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = { initialScale, reverse, transition, transitionEnd, delay };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    className: cx("chakra-offset-slide", className),
    ...scaleFadeConfig,
    animate,
    custom,
    ...rest
  }));
});
ScaleFade.displayName = "ScaleFade";

// src/slide.tsx


var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants4 = {
  exit: ({ direction, transition, transitionEnd, delay }) => {
    const { exit: exitStyles } = getSlideTransition({ direction });
    return {
      ...exitStyles,
      transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: ({ direction, transitionEnd, transition, delay }) => {
    const { enter: enterStyles } = getSlideTransition({ direction });
    return {
      ...enterStyles,
      transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var Slide = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Slide2(props, ref) {
  const {
    direction = "right",
    style,
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    motionProps,
    ...rest
  } = props;
  const transitionStyles = getSlideTransition({ direction });
  const computedStyle = Object.assign({ position: "fixed" }, transitionStyles.position, style);
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = { transitionEnd, transition, direction, delay };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ...rest,
    ref,
    initial: "exit",
    className: cx("chakra-slide", className),
    animate,
    exit: "exit",
    custom,
    variants: variants4,
    style: computedStyle,
    ...motionProps
  }));
});
Slide.displayName = "Slide";

// src/slide-fade.tsx


var variants5 = {
  initial: ({ offsetX, offsetY, transition, transitionEnd, delay }) => ({
    opacity: 0,
    x: offsetX,
    y: offsetY,
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
  }),
  enter: ({ transition, transitionEnd, delay }) => ({
    opacity: 1,
    x: 0,
    y: 0,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
  }),
  exit: ({ offsetY, offsetX, transition, transitionEnd, reverse, delay }) => {
    const offset = { x: offsetX, y: offsetY };
    return {
      opacity: 0,
      transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      ...reverse ? { ...offset, transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit } : { transitionEnd: { ...offset, ...transitionEnd == null ? void 0 : transitionEnd.exit } }
    };
  }
};
var slideFadeConfig = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: variants5
};
var SlideFade = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function SlideFade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    reverse = true,
    className,
    offsetX = 0,
    offsetY = 8,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = {
    offsetX,
    offsetY,
    reverse,
    transition,
    transitionEnd,
    delay
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    className: cx("chakra-offset-slide", className),
    custom,
    ...slideFadeConfig,
    animate,
    ...rest
  }));
});
SlideFade.displayName = "SlideFade";



/***/ }),

/***/ 72457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const Container = _ref => {
  let {
    children,
    paddingY,
    paddingX,
    marginY,
    marginX
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
    as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq,
    maxW: "7xl",
    py: "xxl6",
    paddingY: paddingY || 10,
    marginY: marginY,
    paddingX: paddingX || 0,
    marginX: marginX,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 9460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_VehicleDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/Container/index.tsx
var Container = __webpack_require__(72457);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/grey_car.tsx



const GreyCarIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-334 -1489) translate(334 1489)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        fill: "#C1C7CF"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#464B52",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M4.187 19c.518 0 .938-.42.938-.937v-.938h13.75v.938c0 .517.42.937.937.937h.625c.518 0 .938-.42.938-.937V12.75c0-.687-.197-1.322-.52-1.875h.442c.215 0 .402-.146.454-.355l.235-.937c.074-.296-.15-.583-.455-.583h-2.04l-1.225-3.042C17.791 4.775 16.643 4 15.368 4H8.632c-1.275 0-2.423.775-2.899 1.958L4.508 9H2.47c-.305 0-.529.287-.455.582l.235.938c.049.196.252.355.454.355h.442c-.323.553-.52 1.188-.52 1.875v5.313c0 .517.42.937.937.937h.625zM17.47 9H6.53l.943-2.342c.19-.476.646-.783 1.159-.783h6.736c.513 0 .968.307 1.16.783L17.47 9zm1.405 6.25H5.125c-.345 0-.625-.28-.625-.625V12.75c0-1.034.84-1.875 1.875-1.875h11.25c1.034 0 1.875.841 1.875 1.875v1.875c0 .345-.28.625-.625.625zm-10-1.568c0-.748-1.125-1.87-1.875-1.87s-1.25.499-1.25 1.247c0 .748.5 1.246 1.25 1.246s1.875.125 1.875-.623zm8.125.623c.75 0 1.25-.498 1.25-1.246s-.5-1.247-1.25-1.247-1.875 1.122-1.875 1.87 1.125.623 1.875.623z",
          transform: "translate(4 4)"
        })
      })]
    })
  })
});

/* harmony default export */ var grey_car = (GreyCarIcon);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/VehicleDetails/Column.tsx





const Column = _ref => {
  let {
    title,
    items
  } = _ref;
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
    allowToggle: true,
    allowMultiple: true,
    defaultIndex: 0,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
      border: "0",
      borderBottom: "1px solid #dadde1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
          p: "m",
          _hover: {
            background: 'none'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            flex: "1",
            textAlign: "left",
            fontSize: "1rem",
            fontFamily: "Montserrat-SemiBold",
            textTransform: "uppercase",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
        pb: 4,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
          align: "flex-start",
          children: items && items.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
            columns: 2,
            w: "100%",
            p: "12px",
            className: "accordion-item-mobile-bordered",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
              fontFamily: "Montserrat-Regular",
              fontSize: "1rem",
              letterSpacing: ".2px",
              color: "baseDark",
              display: "inline",
              textTransform: "uppercase",
              textAlign: "left",
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
              fontFamily: "Montserrat-SemiBold",
              fontSize: "1.1rem",
              letterSpacing: ".3px",
              color: "baseDark",
              display: "inline",
              textAlign: "right",
              children: item.value
            })]
          }, item.name))
        })
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    w: "full",
    bg: "baseWhite",
    p: 6,
    overflow: "hidden",
    padding: "unset",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      fontFamily: "Montserrat-SemiBold",
      fontSize: ".875rem",
      lineHeight: "18px",
      letterSpacing: ".2px",
      textAlign: "center",
      color: "baseDark",
      textTransform: "uppercase",
      paddingY: "m",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
      bg: "baseNeutral.300",
      height: ".125rem"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
      paddingX: "xl",
      paddingY: "l",
      children: items.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        position: "relative",
        textAlign: "left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
          paddingY: ".875rem",
          paddingX: "s",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            fontFamily: "Montserrat-Regular",
            fontSize: "1rem",
            lineHeight: "20.8px",
            letterSpacing: ".2px",
            color: "baseDark",
            display: "inline",
            textTransform: "uppercase",
            children: item.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1.1rem",
            lineHeight: "23px",
            letterSpacing: ".3px",
            float: "right",
            color: "baseDark",
            display: "inline",
            children: item.value
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
          bg: "baseNeutral.300",
          height: ".062rem"
        })]
      }, `${item.name}-${item.value}`))
    })]
  });
};

/* harmony default export */ var VehicleDetails_Column = (Column);
;// CONCATENATED MODULE: ./src/components/VehicleDetails/index.tsx








const TitleContent = /*#__PURE__*/styled_components_browser_esm["default"].span.withConfig({
  componentId: "sc-1xcx72b-0"
})(["& svg{display:inline;margin-right:0.5rem;margin-bottom:-6px;}"]);

const VehicleDetails = _ref => {
  let {
    title,
    engineTitle,
    engine,
    dimensionsTitle,
    dimensions,
    consumptionTitle,
    consumption,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bg: "baseNeutral.200",
    paddingY: {
      base: 0,
      md: 'xxl6'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      paddingY: "0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        bg: "baseNeutral.300",
        padding: "m",
        borderTopRadius: {
          base: '0',
          md: '10'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          as: "h2",
          fontFamily: "Montserrat-SemiBold",
          fontSize: {
            base: '1.25rem',
            md: '1.5rem'
          },
          lineHeight: "31px",
          letterSpacing: {
            base: '0.58px',
            md: '0.68px'
          },
          textAlign: "center",
          color: "baseDark",
          py: "xxl",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContent, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
              display: {
                base: 'none',
                md: 'inline'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(grey_car, {})
            }), title]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          sm: 2,
          md: 3
        },
        spacing: "l",
        textAlign: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetails_Column, {
          title: engineTitle,
          items: engine
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetails_Column, {
          title: dimensionsTitle,
          items: dimensions
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetails_Column, {
          title: consumptionTitle,
          items: consumption
        })]
      }), children && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        pt: "m",
        pb: {
          base: 'l',
          md: 0
        },
        children: children
      })]
    })
  });
};

/* harmony default export */ var components_VehicleDetails = (VehicleDetails);

/***/ })

}]);